import React, { Fragment, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import "./Auth.scss";
import PlanetCard from "../PlanetCard/PlanetCard";
import { AUTH_MODE } from "../../constants/enums";
import { useTranslation } from "react-i18next";
import { MenuItem, Select } from "@mui/material";
import { changeLanguage } from "i18next";
declare const changeBrowserLang: any;
function Auth() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const authMode = location.pathname.includes("verify-email")
    ? AUTH_MODE.EMAIL_VERIFY
    : location.pathname.includes("register-supplier")
    ? AUTH_MODE.SUPPLIER
    : location.pathname.includes("audit-request")
    ? AUTH_MODE.EXTERNAL_VERIFIER
    : AUTH_MODE.SIGNIN;
  const [Language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );

  //   const navigateToContacts = () => {
  //     // 👇️ navigate to /contacts
  //     navigate('/auth/login');
  //   };
  const handleChangeLanguage = (event: any) => {
    const lang = event.target.value;
    // if (lang) {
    //   setLanguage(true);
    // } else {
    //   setLanguage(false);
    // }
    // setLanguage(lang === "en" ? "English" : "ภาษาไทย");
    setLanguage(lang);

    localStorage.setItem("language", lang);
    changeBrowserLang(lang);
    // i18n.changeLanguage(lang);
  };

  return (
    <div className="flex">
      <PlanetCard />
      <div className="flex flex-col pw-auth pw-height-100v pw-overflow-y-auto">
        <div className="pw-tab-label flex flex-row items-center justify-between">
          <div className="flex gap-8 items-center">
            {authMode === AUTH_MODE.SIGNIN && (
              <Fragment>
                <NavLink
                  to="login"
                  style={({ isActive }) =>
                    isActive
                      ? { color: "#1D2025", fontWeight: 600, fontSize: 22 }
                      : { color: "#AFBACA", fontSize: 18 }
                  }
                >
                  {t("Sign In")}
                </NavLink>
                <NavLink
                  to="register"
                  style={({ isActive }) =>
                    isActive
                      ? { color: "#1D2025", fontWeight: 600, fontSize: 22 }
                      : { color: "#AFBACA", fontSize: 18 }
                  }
                >
                  {t("signUp")}
                </NavLink>
              </Fragment>
            )}
            {authMode === AUTH_MODE.EMAIL_VERIFY && (
              <NavLink
                to="verify-email"
                style={({ isActive }) =>
                  isActive
                    ? { color: "#1D2025", fontWeight: 600, fontSize: 22 }
                    : { color: "#AFBACA", fontSize: 18 }
                }
              >
                {t("Activate Account")}
              </NavLink>
            )}
            {authMode === AUTH_MODE.SUPPLIER && (
              <p className="text-3xl">Supplier/Borrower</p>
            )}
            {authMode === AUTH_MODE.EXTERNAL_VERIFIER && (
              <p className="text-3xl">External Verifier</p>
            )}
          </div>
          <Select
            value={Language}
            className="pw-register-language"
            onChange={handleChangeLanguage}
          >
            <MenuItem value="en" key="2">
              {t("English")}
            </MenuItem>
            <MenuItem className="no-translate" value="th" key="1">
              ภาษาไทย
            </MenuItem>

            {/* <MenuItem value="hi" key="tCO2e">
                  {t("Hindi")}
                </MenuItem> */}
          </Select>
        </div>

        <Outlet />
      </div>
    </div>
  );
}

export default Auth;
